import { Object } from 'fabric/fabric-impl';

let _first: Object | null = null;

const firstSelection = {
  get: (): Object | null => _first,
  set: (obj: Object | null) => {
    _first = obj;
  },
};

export default firstSelection;
